import {LANGUAGE} from '@/constant/language';

const numberFormats = {
  [LANGUAGE.EN_US]: {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
  },
  [LANGUAGE.ZH_TW]: {
    currency: {
      style: 'currency',
      currency: 'TWD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  [LANGUAGE.ZH_CN]: {
    currency: {
      style: 'currency',
      currency: 'CNY',
    },
  },
  [LANGUAGE.JA_JP]: {
    currency: {
      style: 'currency',
      currency: 'JPY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
};
export default numberFormats;
